import { IMultipleIdsParams } from '../types/actionParams';
import { IResult } from '../types/IResponse';
import { Request } from './Request';

export interface IRunExtractRefreshesOnDatasourcesParams extends IMultipleIdsParams {
  type: string; // ExtractTaskType
}

export class RunExtractRefreshesOnDatasourcesRequest extends Request<IRunExtractRefreshesOnDatasourcesParams, IResult> {
                          // type must be from ExtractTaskType
  constructor(ids: string[], type: string) {
    super('runExtractRefreshesOnDatasources', {
      ids: ids,
      type: type
    });
  }
}
